import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { useLanguage } from '../Context/LanguageContext'; // Adjust path if needed
import './CSS/Login.css';

const Login = ({ setRole }) => {
  const { t } = useLanguage(); // Get translations
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('https://weynibirhan.com.et/login.php', {
        email,
        password,
      });

      const data = response.data;
      setMessage(data.message);

      if (data.status === 'success') {
        const userRole = data.user?.role || 'user';
        localStorage.setItem('role', userRole);
        localStorage.setItem('email', data.user.email);

        // Update App state so navbar updates immediately
        setRole(userRole);

        // Redirect to home
        navigate('/');
      }
    } catch (error) {
      console.error('Login error:', error);
      setMessage(t.login_failed || 'Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>{t.nav_login_signup}</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder={t.login_email || 'Email'}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder={t.login_password || 'Password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">{t.login_button || 'Login'}</button>
        </form>
        {message && <p className="message">{message}</p>}
        <p>
          {t.login_no_account || "Don't have an account?"}{' '}
          <Link to="/register">{t.login_register_here || 'Register here'}</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
